import { api } from "@/lib/api";

export async function runHygieneCheck(pageId) {
  try {
    const { data } = await api.post(`/pages/${pageId}/hygiene-check`);
    return data.has_mismatches ? data.mismatches || [] : [];
  } catch {
    return [];
  }
}
